import type { TOC } from '@ember/component/template-only';
import { PhList } from 'ember-phosphor-icons';

export interface TioHeaderMenuButtonSignature {
  Args: {
    onClick: () => void;
  };
  Element: HTMLButtonElement;
}

const TioHeaderMenuButtonComponent: TOC<TioHeaderMenuButtonSignature> = <template>
  <button class="tio-header-menu-button" type="button" {{on "click" @onClick}} ...attributes>
    <span class="sr-only">Open menu</span>
    <PhList @size="24" />
  </button>
</template>;

export default TioHeaderMenuButtonComponent;
